<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <p-dropdown
    class="dropdown"
    [inputId]="id()"
    [placeholder]="placeholder()"
    [options]="options()"
    (onChange)="updateValue($event.value)"
    [ngModel]="value()"
    (onBlur)="markAsTouched()">
    <ng-template let-option pTemplate="item">
      <div class="dropdown__item">
        <span>{{ option.data.flag }}</span>
        <span>{{ option.label }}</span>
      </div>
    </ng-template>

    <ng-template let-selected pTemplate="selectedItem">
      @if (selected) {
        <div class="dropdown__item">
          <span>{{ selected.data.flag }}</span>
          <span>{{ selected.label }}</span>
        </div>
      }
    </ng-template>
  </p-dropdown>
</ui-control-field>
